import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AUTH_USE_REFRESH_TOKENS, AuthConfig } from '@capturum/auth';
import { NeqtoAuthService } from '@shared/services/neqto-auth.service';
import { UserService } from '@shared/services/user.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(NeqtoAuthService);
  const userService = inject(UserService);
  const router = inject(Router);
  const config = inject(AuthConfig);
  const authRefreshToken = inject(AUTH_USE_REFRESH_TOKENS);
  const checkUseRefreshToken = () => {
    if (authRefreshToken.useRefreshToken || config?.authRefreshToken?.useRefreshToken) {
      authService.watchRefreshToken();
    }
  };

  if (authService.isAuthenticated()) {
    const user = authService.getUser();

    userService.userStateActions.patchUser(user);
    checkUseRefreshToken();

    return true;
  }

  router.navigate([config.authRejectionRoute], { queryParams: { redirectUrl: window.location.pathname } });

  return false;
};
